export const changeSliderLabels = (value, labelTexts) => {

  const selectedLabel = labelTexts.find(label => label.value === value) || {};

  return selectedLabel.translatedLabel || 'labelSelector';
};

export default changeSliderLabels;
